import React, { useState } from 'react';
import { Analytics } from '@vercel/analytics/react';
import LandingPage from './components/LandingPage';
import ChoiceHub from './components/ChoiceHub';
import DashboardLayout from './components/DashboardLayout';
import AiAgentPage from './components/AiAgentPage';
import TaxCalculatorPage from './components/TaxCalculatorPage';
import GreenCardCalculatorPage from './components/GreenCardCalculatorPage';

type ViewState = 'landing' | 'hub' | 'prediction' | 'ai' | 'tax' | 'greencard';

const App: React.FC = () => {
  const [view, setView] = useState<ViewState>('landing');
  const [language, setLanguage] = useState<string>('en');

  const handleStart = (selectedLanguage: string) => {
    setLanguage(selectedLanguage);
    setView('hub');
  };

  const handleSelectTool = (tool: 'prediction' | 'ai' | 'tax' | 'greencard') => {
    setView(tool);
  };

  const handleBackToLanding = () => {
    setView('landing');
  };

  const handleBackToHub = () => {
    setView('hub');
  };

  return (
    <div className="h-full w-full">
      {view === 'landing' && (
        <LandingPage onStart={handleStart} />
      )}
      
      {view === 'hub' && (
        <ChoiceHub 
          language={language} 
          onSelect={handleSelectTool} 
          onBack={handleBackToLanding} 
        />
      )}

      {view === 'prediction' && (
        <DashboardLayout 
          onBack={handleBackToHub} 
          onHome={handleBackToLanding}
          onExploreAi={() => setView('ai')}
          language={language} 
        />
      )}

      {view === 'ai' && (
        <div className="h-full w-full bg-white">
          <AiAgentPage 
            isRTL={language === 'ar'} 
            language={language} 
            onBack={handleBackToHub} 
            onHome={handleBackToLanding}
          />
        </div>
      )}

      {view === 'tax' && (
        <TaxCalculatorPage 
          language={language}
          onBack={handleBackToHub}
          onHome={handleBackToLanding}
        />
      )}

      {view === 'greencard' && (
        <GreenCardCalculatorPage 
          language={language}
          onBack={handleBackToHub}
          onHome={handleBackToLanding}
        />
      )}

      <Analytics />
    </div>
  );
};

export default App;